module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/reports/Variance-empty.ejs -->\n<h1 class="text-center">\n    There are no submitted\n    or completed payrolls to report on\n</h1>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/reports/Variance-empty.ejs
// module id = 834
// module chunks = 1